import React, { Children } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';

export default function SampleEditGrid({ children }) {
  const items = Children.toArray(children);

  return (
    <Grid container size={12} spacing={0}>
      <Grid size={12}>{items[0]}</Grid>
      <Grid size={12}>{items[1]}</Grid>
      <Grid container size={12} spacing={2}>
        <Grid size={6}>{items[2]}</Grid>
        <Grid size={6}>{items[3]}</Grid>
      </Grid>
      <Grid size={12}>{items[4]}</Grid>
      <Grid size={12}>{items[5]}</Grid>
      <Grid size={12}>{items[6]}</Grid>
      <Grid size={12}>{items[7]}</Grid>
      <Grid size={12}>{items[8]}</Grid>
    </Grid>
  );
}

SampleEditGrid.propTypes = {
  children: PropTypes.node,
};
